<template>
  <div class="news">
    <div class="banner">
      <h3>X联网动态</h3>
      <p>见证每一次的改变</p>
    </div>

    <div class="box40"></div>
    <div class="w1200 container">
      <ul :class="tableData.length>9?'h2650':''" v-infinite-scroll="loadData" style="overflow:auto" >
        <li v-for="(items,index) in tableData" :key="index" class="items clear" @click="$router.push('/news/newsDetail/'+items.id)">
          <div class="mask" v-if="items.imgs && items.imgs.length > 0"></div>
          <img class="right" v-if="items.imgs && items.imgs.length > 0" :src="items.imgs[0]" alt />
          <div class="discription">
            <div
              class="title ellipsis-2 height90"
            >{{items.listTitle}}</div>
            <p
              class="cont ellipsis-3 height90"
            >{{items.summary}}</p>
            <div class="clear">
              <em>{{items.addTime1}}</em>
              <em>来源：{{items.source}}</em>
              <em>作者：{{items.author}}</em>
            </div>
          </div>
        </li>
      </ul>
      <div class="loading" v-if="loading">
        <i class="el-icon-loading"></i>
      </div>
    </div>

    <div class="d_footer">
      <h4>欢迎垂询</h4>
      <p>欢迎关注官方微信“数说产业互联网”，阅读更多精彩文章。也可以扫描下方二维码添加关注。数说产业互联网将为您提供更多解决方案</p>
      <div class="box20"></div>
      <ul class="imgList w1200 clear">
        <li>
          <div class="mask">
            <div class="desc">
              <p>乡村振兴数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/0')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_01.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农业单品行业大数据解决方案</p>
              <div class="link" @click="routerLink('/solution/1')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_02.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农业链主企业数字 化解决方案</p>
              <div class="link" @click="routerLink('/solution/2')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_03.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>现代农业产业园数 字化解决方案</p>
              <div class="link" @click="routerLink('/solution/3')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_04.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农产品区域公用品牌数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/4')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_05.png" alt />
        </li>
        <li>
          <div class="mask">
            <div class="desc">
              <p>农产品交易中心数字化解决方案</p>
              <div class="link" @click="routerLink('/solution/5')">了解更多></div>
            </div>
          </div>
          <img src="@/assets/lib/images/sec4_06.png" alt />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagination: {
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      scrollTop: 0,
      tableData: []
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    routerLink(url) {
      this.$router.push(url);
    },
    loadData() {
      //this.loading = true
      this.$store
        .dispatch("api/selContentList", {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          concludeImage: '1',
          tagNames: 'X联网,X联网动态'
        })
        .then(response => {
          this.pagination.pageNum ++
          if(response && response.list && response.list.length > 0) {
            this.tableData.push(...response.list)
            if(this.tableData.length >= response.total) {
              this.loading = false
            }
          }else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/pc/css/news.scss";
</style>